<template>
  <section class="component--wrapper">
    <el-row>
      <el-col :xl="24">
        <h1>
          <b>Vamos criar a sua loja.</b>
        </h1>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xl="24">
        <el-form
          v-loading="submitLoading"
          ref="storeForm"
          :rules="rules"
          :model="storeForm"
          style="max-width: 700px; margin: 0 auto;"
        >
          <el-form-item v-if="!$isMobile" prop="document">
            <el-input
              :mask="documentMask"
              :placeholder="documentPlaceholder"
              v-model="storeForm.document"
              @input="updateMask"
            >
              <template slot="prepend">CPF/CNPJ:</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="document" v-else>
            <el-input
              :mask="documentMask"
              :placeholder="documentPlaceholder"
              v-model="storeForm.document"
              @input="updateMask"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" v-if="!$isMobile">
            <el-input :disabled="!continueForm" v-model="storeForm.name">
              <template slot="prepend">Nome da loja:</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="name" v-else>
            <el-input
              :disabled="!continueForm"
              placeholder="Nome da loja"
              v-model="storeForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email" v-if="!$isMobile">
            <el-input
              :disabled="!continueForm"
              type="email"
              v-model="storeForm.email"
            >
              <template slot="prepend">E-mail da loja:</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="email" v-else>
            <el-input
              :disabled="!continueForm"
              placeholder="E-mail da loja"
              type="email"
              v-model="storeForm.email"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phone" v-if="!$isMobile">
            <el-input
              v-mask="['(##) #####-####', '(##) ####-####']"
              :disabled="!continueForm"
              v-model="storeForm.phone"
            >
              <template slot="prepend">Telefone da loja:</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="phone" v-else>
            <el-input
              v-mask="['(##) #####-####', '(##) ####-####']"
              :disabled="!continueForm"
              placeholder="Telefone da loja"
              v-model="storeForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="postalCode" v-if="!$isMobile">
            <el-input
              @input="cepAutoComplete(storeForm.postalCode)"
              v-mask="'#####-###'"
              :disabled="!continueForm"
              v-model="storeForm.postalCode"
            >
              <template slot="prepend">CEP:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-else prop="postalCode">
            <el-input
              @input="cepAutoComplete(storeForm.postalCode)"
              v-mask="'#####-###'"
              :disabled="!continueForm"
              placeholder="CEP"
              v-model="storeForm.postalCode"
            ></el-input>
          </el-form-item>
          <el-form-item v-loading="loading" prop="street" v-if="!$isMobile">
            <el-input :disabled="!cepPromise" v-model="storeForm.street">
              <template slot="prepend">Logradouro:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-loading="loading" v-else prop="street">
            <el-input
              :disabled="!cepPromise"
              placeholder="Logradouro"
              v-model="storeForm.street"
            ></el-input>
          </el-form-item>
          <el-form-item v-loading="loading" prop="number" v-if="!$isMobile">
            <el-input :disabled="!cepPromise" v-model="storeForm.number">
              <template slot="prepend">Número:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-loading="loading" v-else prop="number">
            <el-input
              :disabled="!cepPromise"
              placeholder="Número"
              v-model="storeForm.number"
            ></el-input>
          </el-form-item>
          <el-form-item v-loading="loading" prop="complement" v-if="!$isMobile">
            <el-input :disabled="!cepPromise" v-model="storeForm.complement">
              <template slot="prepend">Complemento:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-loading="loading" v-else prop="complement">
            <el-input
              :disabled="!cepPromise"
              placeholder="Complemento"
              v-model="storeForm.complement"
            ></el-input>
          </el-form-item>
          <el-form-item v-loading="loading" prop="neighborhood" v-if="!$isMobile">
            <el-input :disabled="!cepPromise" v-model="storeForm.neighborhood">
              <template slot="prepend">Bairro:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-loading="loading" v-else prop="neighborhood">
            <el-input
              :disabled="!cepPromise"
              placeholder="Bairro"
              v-model="storeForm.neighborhood"
            ></el-input>
          </el-form-item>
          <el-form-item v-loading="loading" prop="city" v-if="!$isMobile">
            <el-input :disabled="!cepPromise" v-model="storeForm.city">
              <template slot="prepend">Cidade:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-loading="loading" v-else prop="city">
            <el-input
              :disabled="!cepPromise"
              placeholder="Cidade"
              v-model="storeForm.city"
            ></el-input>
          </el-form-item>
          <el-form-item v-loading="loading" prop="uf" v-if="!$isMobile">
            <el-input :disabled="!cepPromise" v-model="storeForm.uf">
              <template slot="prepend">UF:</template>
            </el-input>
          </el-form-item>
          <el-form-item v-loading="loading" v-else prop="uf">
            <el-input
              :disabled="!cepPromise"
              placeholder="UF"
              v-model="storeForm.uf"
            ></el-input>
          </el-form-item>
          <el-form-item class="terms-form-item" prop="terms">
            <el-checkbox-group v-model="storeForm.terms">
              <el-checkbox name="terms" :label="useTerms">
                <p class="checkbox-p">
                  Li e aceito os
                  <a
                    href="https://www.neopag.com/termos-de-uso-aplicativo"
                    target="_blank"
                  >Termos de uso</a>
                  e
                  <a
                    href="https://www.neopag.com/politica-de-privacidade"
                    target="_blank"
                  >Política de privacidade</a>
                  do site.
                </p>
              </el-checkbox>
              <el-checkbox name="terms" :label="truePerson">
                <p class="checkbox-p">
                  Sou representante legal da loja cadastrada e tenho poderes
                  para contratar.
                </p>
              </el-checkbox>
              <el-checkbox name="terms" :label="contractTerms">
                <p class="checkbox-p">
                  Li e adiro aos
                  <a
                    href="https://www.neopag.com/contrato-loja"
                    target="_blank"
                  >Termos do contrato de prestação de serviços</a>.
                </p>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-button type="success" @click="handleSubmit('storeForm')">Finalizar Cadastro</el-button>
        </el-form>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import cep from "cep-promise";

export default {
  props: {
    knowAnswer: {
      type: String,
      default: ""
    },
    segmentAnswer: {
      type: String,
      default: ""
    },
    howManyAnswer: {
      type: String,
      default: "1"
    },
    howMuchAnswer: {
      type: String,
      default: "0"
    },
    weCanHelpAnswer: {
      type: String,
      default: ""
    }
  },
  data() {
    // Função de validação para CPF
    const isCPF = (value) => {
      if (!value) return false;
      const cleanCPF = value.replace(/\D/g, "");
      if (cleanCPF.length !== 11) return false;

      // Validação básica de CPF
      let sum = 0;
      let rest;
      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cleanCPF[i - 1]) * (11 - i);
      }
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(cleanCPF[9])) return false;

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cleanCPF[i - 1]) * (12 - i);
      }
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(cleanCPF[10])) return false;

      // Verifica dígitos repetidos (ex.: 111.111.111-11)
      if (/^(\d)\1+$/.test(cleanCPF)) return false;

      return true;
    };

    // Função de validação para CNPJ
    const isCNPJ = (value) => {
      if (!value) return false;
      const cleanCNPJ = value.replace(/\D/g, "");
      if (cleanCNPJ.length !== 14) return false;

      // Verifica dígitos repetidos (ex.: 11.111.111/1111-11)
      if (/^(\d)\1+$/.test(cleanCNPJ)) return false;

      // Validação do primeiro dígito verificador
      let sum = 0;
      const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      for (let i = 0; i < 12; i++) {
        sum += parseInt(cleanCNPJ[i]) * weights1[i];
      }
      let rest = sum % 11;
      const digit1 = rest < 2 ? 0 : 11 - rest;
      if (digit1 !== parseInt(cleanCNPJ[12])) return false;

      // Validação do segundo dígito verificador
      sum = 0;
      const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      for (let i = 0; i < 13; i++) {
        sum += parseInt(cleanCNPJ[i]) * weights2[i];
      }
      rest = sum % 11;
      const digit2 = rest < 2 ? 0 : 11 - rest;
      if (digit2 !== parseInt(cleanCNPJ[13])) return false;

      return true;
    };

    const checkDocument = (rule, value, callback) => {
      const cleanValue = value.replace(/\D/g, "");
      const isValidCNPJ = cleanValue.length === 14 && isCNPJ(cleanValue);
      const isValidCPF = cleanValue.length === 11 && isCPF(cleanValue);

      if (!isValidCNPJ && !isValidCPF) {
        this.continueForm = false;
        return callback(new Error("Por favor, insira um CPF ou CNPJ válido"));
      } else {
        this.continueForm = true;
        callback();
      }
    };

    const checkEmail = async (rule, value, callback) => {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        return callback(new Error("Por favor insira um email válido"));
      } else {
        try {
          await this.resetEmailGetter();
          await this.checkEmailAlreadyExist(value);
          if (!this.user.registered_in_app) {
            callback();
          } else {
            return callback();
          }
        } catch (error) {}
      }
    };

    const checkNumber = async (rule, value, callback) => {
      const cleanNumber = value.replace(/[()-\s]/g, "");
      if (cleanNumber.length < 10) {
        return callback(new Error("Insira um número de celular válido."));
      } else {
        callback();
      }
    };

    const checkCEP = async (rule, value, callback) => {
      const cleanCEP = value.replace(/[-]/g, "");
      if (cleanCEP.length === 8) {
        callback();
      } else {
        await this.$store.dispatch(types.RESET_LAT_LNG, null);
        this.loading = false;
        callback(new Error("Digite um CEP válido"));
      }
    };

    const checkTerms = (rule, value, callback) => {
      if (value.length === 3) {
        callback();
      } else {
        callback(new Error("Você deve concordar com todos os termos"));
      }
    };

    const checkStreet = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Você deve preencher esse campo."));
      } else {
        callback();
      }
    };

    const checkNeighborhood = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Você deve preencher esse campo."));
      } else {
        callback();
      }
    };

    const checkCity = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Você deve preencher esse campo."));
      } else {
        callback();
      }
    };

    const checkUf = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Você deve preencher esse campo."));
      } else {
        callback();
      }
    };

    return {
      useTerms: "useTerms",
      truePerson: "truePerson",
      contractTerms: "contractTerms",
      continueForm: false,
      cepPromise: null,
      loading: false,
      submitLoading: false,
      captched: true,
      storeForm: {
        document: "",
        name: "",
        email: "",
        phone: "",
        postalCode: "",
        street: "",
        number: null,
        complement: "",
        neighborhood: "",
        city: "",
        uf: "",
        terms: []
      },
      rules: {
        document: [
          {
            required: true,
            trigger: "change",
            validator: checkDocument
          }
        ],
        name: [
          {
            required: true,
            trigger: "blur",
            message: "Você deve dar um nome a sua loja"
          }
        ],
        email: [
          {
            required: true,
            trigger: "change",
            validator: checkEmail
          }
        ],
        phone: [
          {
            required: true,
            trigger: "change",
            validator: checkNumber
          }
        ],
        postalCode: [
          {
            required: true,
            trigger: "change",
            validator: checkCEP
          }
        ],
        terms: [
          {
            type: "array",
            required: true,
            trigger: "change",
            validator: checkTerms
          }
        ],
        number: [
          {
            required: true,
            trigger: "blur",
            message: "O número é obrigatório"
          }
        ],
        street: [
          {
            required: true,
            trigger: "change",
            validator: checkStreet
          }
        ],
        neighborhood: [
          {
            required: true,
            trigger: "change",
            validator: checkNeighborhood
          }
        ],
        city: [
          {
            required: true,
            trigger: "change",
            validator: checkCity
          }
        ],
        uf: [
          {
            required: true,
            trigger: "change",
            validator: checkUf
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      user: types.AUTH_USER,
      userByCpf: types.USER_INFO_BY_CPF,
      location: types.LAT_LNG
    }),
    documentMask() {
      const cleanValue = this.storeForm.document.replace(/\D/g, "");
      return cleanValue.length > 11 ? "##.###.###/####-##" : "###.###.###-##";
    },
    documentPlaceholder() {
      const cleanValue = this.storeForm.document.replace(/\D/g, "");
      return cleanValue.length > 11 ? "12.123.456/0001-78" : "123.456.789-01";
    }
  },
  methods: {
    handleSubmit(form) {
      this.$refs[form].validate(async valid => {
        if (valid && this.captched) {
          const payload = {
            store: {
              name: this.storeForm.name,
              email: this.storeForm.email,
              cnpj: this.storeForm.document.replace(/\D/g, ""),
              phone: `+55${this.storeForm.phone.replace(/[()-\s]/g, "")}`,
              category_id: this.segmentAnswer,
              onboardin_questions: {
                type: this.knowAnswer,
                how_many: this.howManyAnswer,
                how_much: this.howMuchAnswer,
                help: this.weCanHelpAnswer
              },
              address: {
                street: this.storeForm.street,
                number: this.storeForm.number,
                city: this.storeForm.city,
                uf: this.storeForm.uf,
                cep: this.storeForm.postalCode,
                complement: this.storeForm.complement,
                latitude: this.location?.lat,
                longitude: this.location?.lng
              }
            },
            user_id: this.user.id
          };
          try {
            await this.$store.dispatch(types.STORE_CREATE, {
              payload
            });
            this.$emit("finalStepEvent");
            this.$notify.success("Loja criada com sucesso.");
          } catch (error) {
            if (this.$raven && error.status === 500) {
              this.$raven.captureException(error.message, { req: error });
            }
            this.$notify.error({ title: error.message });
          }
        } else {
          return false;
        }
      });
      this.submitLoading = false;
    },
    async cepAutoComplete(value) {
      const cleanCEP = value.replace(/[-]/g, "");
      if (cleanCEP.length === 8) {
        this.loading = true;
        try {
          this.cepPromise = await cep(cleanCEP);
          this.storeForm.street = this.cepPromise.street;
          this.storeForm.city = this.cepPromise.city;
          this.storeForm.uf = this.cepPromise.state;
          this.storeForm.neighborhood = this.cepPromise.neighborhood;
          await this.$store.dispatch(types.GET_LAT_LNG, {
            cep: cleanCEP,
            uglyCep: value
          });
          this.loading = false;
        } catch (error) {
          await this.$store.dispatch(types.RESET_LAT_LNG, null);
          this.$notify.error(
            "Ocorreu um erro, por favor digite o CEP novamente."
          );
          this.loading = false;
        }
      }
    },
    updateMask() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
.component--wrapper {
  margin: 1rem auto 0 auto;
  text-align: center;
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 5px;
  max-width: 700px;
  a {
    color: $laranja;
    text-decoration: none;
  }
  .el-form-item__content {
    label {
      .el-checkbox__label {
        p {
          @media screen and(max-width: 767px) {
            font-size: 0.7rem;
          }
        }
      }
    }
  }
  .btn--wrapper {
    margin-left: 1rem;
  }
  .terms-form-item {
    margin: 0.2rem !important;
    text-align: start;
  }
}
</style>